(function () {
  'use strict';

  angular
    .module('app.account-loyalty-points', [])

    .component('accountLoyaltyPoints', {
      bindings: {
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountLoyaltyPoints;
      }],
      /* @ngInject */
      controller: ["$scope", "$location", "AccountService", "HttpService", "AppService", function ($scope, $location, AccountService, HttpService, AppService) {
        var ctrl = this;

        AccountService.initAccount(ctrl);

        this.$onInit = function () {

          $scope.device = ctrl.device;
          ctrl.loading = true;

          AppService.getParams()
            .then(function (params) {
              if (!params.Account.IsManagementLoyaltyPoints) {
                $location.path(ctrl.links.AccountHome);
              } else {
                loadData();
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        // Functions
        function loadData() {
          HttpService.get({
            url: '/AccountLoyaltyPoints/Get',
            cache: false
          })
          .then(function (response) {

            ctrl.Visitor = response.results.Visitor;
            ctrl.LoyaltyPointsAcquired = [];
            var now = new Date();
            _.each(response.results.LoyaltyPointsAcquired, function (item) {
              item.endDate = new Date(item.DateEndValidity.replace('T', ' ').replace(/-/g, '/'));
              if (item.endDate > now) {
                var soon = new Date();
                soon.setMonth(soon.getMonth() + 1);
                if (item.endDate < soon) {
                  item.expiresSoon = true;
                }
                ctrl.LoyaltyPointsAcquired.push(item);
              }
            });

            AppService.getParams()
              .then(function (params) {
                ctrl.Visitor.LoyaltyProgram.AmountForOnePoint = getPrice(ctrl.Visitor.LoyaltyProgram.AmountForOnePoint, params);
                ctrl.Visitor.LoyaltyProgram.TriggerValue = getPrice((ctrl.Visitor.LoyaltyProgram.ValuePerPoint * ctrl.Visitor.LoyaltyProgram.TriggerPointNumber).toFixed(2), params, true);
                ctrl.Visitor.LoyaltyProgram.ValuePerPoint = getPrice(ctrl.Visitor.LoyaltyProgram.ValuePerPoint, params);
                ctrl.init = true;
                ctrl.loading = false;
              });

          })
          .catch(function (error) {
            console.error(error);
          });
        }

        function getPrice(value, params, noDecimal) {
          var loc = params.Localization,
            template = loc.PriceHTMLFormatVATincluded,
            priceFormat = noDecimal ? '0.##' : loc.PriceFormat;
          var render = template.replace('[%amount%]', format(priceFormat, parseFloat(value)))
                               .replace(',', '##PriceTSep##')
                               .replace('.', loc.PriceDecimalSeparator)
                               .replace('[%amountCode%]', format(loc.PriceFormat, parseFloat(value)))
                               .replace('##PriceTSep##', loc.PriceThousandSeparator)
                               .replace('[%currency%]', params.Currency.Symbol)
                               .replace('[%currencyCode%]', params.Currency.ISOCode);
          return render;
        }

      }],
      controllerAs: 'accountCtrl'
    });

})();
